
export default {
    menuHide: false,
    menuCollapse: false,
    menus: [],
    menuGroups: [],
    subGroups: [],
    currentMenuType: '',
    currentMenu: {},
    loginUser: {},
    loginCust: {},
    loginType: '',
    project: null,
    layoutComp: { compLib: "jdc", compName: "LayoutBlank" },
};
